/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';

export default {
  setProjects(state, projects) {
    state.projects = projects;
  },
  setActiveTimezone(state, timezone) {
    state.activeTimezone = timezone;
  },
  setError(state, error) {
    state.error = error;
  },
  startLoading(state, moduleName) {
    Vue.set(state.activeLoaders, moduleName, true);
  },
  stopLoading(state, moduleName) {
    Vue.set(state.activeLoaders, moduleName, false);
  },
  setResponseError(state, moduleName) {
    this.commit('stopLoading', moduleName);
    state.error = 'Something went wrong';
  },
  setBackToPath(state, path) {
    state.backToPath = path;
  },
  toggleSidebar(state) {
    state.sidebarOpen = !state.sidebarOpen;
  },
  toggleDarkMode(state, mode) {
    Vue.localStorage.set('darkMode', mode);
    Vue.set(state, 'darkMode', mode);
    document.body.className = `theme-${mode ? 'dark' : 'light'}`;
  }
};
